import links from './links';
import multiChoiceSelects from './multi-choice-selects';

export default () => {
  links();
  multiChoiceSelects();
}
